import React from "react";

interface ReviewCardProps {
  rating: number;
  title: string;
  body: string;
  reviewerName: string;
  reviewerImage: string;
  date: string;
}

const ReviewCard: React.FC<ReviewCardProps> = ({
  rating,
  title,
  body,
  reviewerName,
  reviewerImage,
  date,
}) => {
  return (
    <div className="dui-review-card">
      <div className="dui-review-card-rating">
        {[...Array(5)].map((_, index) => (
          <span
            key={index}
            className={`dui-review-card-star ${
              index < rating ? "filled" : "empty"
            }`}
          >
            ★
          </span>
        ))}
      </div>
      <h3 className="dui-review-card-title">{title}</h3>
      <p className="dui-review-card-body">{body}</p>
      <div className="dui-review-card-reviewer">
        <img
          src={reviewerImage}
          alt={reviewerName}
          className="dui-review-card-reviewer-image"
        />
        <div className="dui-review-card-reviewer-info">
          <p className="dui-review-card-reviewer-name">{reviewerName}</p>
          <p className="dui-review-card-reviewer-date">{date}</p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;

